export default __webpack_public_path__ + "static/media/shortcut.eb056c73.svg";